<template>
    <div>
        <main>
            <header>
                <div class="tw-container">
                    <img src="~@/assets/img/logo.svg">
                </div>
            </header>
            <section class="hero">
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
                    <div class="info-container" v-if="!$store.state.formSuccess">
                        <small>Apenas 30 vagas</small>
                        <h1>Teste Grátis o Aparelho <br class="lg:tw-hidden">Auditivo ampli-mini</h1>
                    </div>
                    <div class="form-container">
                        <Form v-if="!$store.state.formSuccess" />
                        <FormSuccess v-if="$store.state.formSuccess" />
                    </div>
                </div>
            </section>
            <footer>
                <!-- <img src="@/assets/img/footer-bg-mobile.svg" class="tw-block lg:tw-hidden">
                <img src="@/assets/img/footer-bg.svg" class="tw-hidden lg:tw-block"> -->
                <div class="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-5 tw-mx-auto tw-w-fit">
                    <div>
                        <h3 class="tw-absolute tw-opacity-0 tw-pointer-events-none">Teste Grátis</h3>
                        <img src="@/assets/img/footer-img.png" alt="TESTE GRÁTIS" class="tw-pointer-events-none">
                    </div>
                    <div>
                        <h4>Aparelho Auditivo ampli-mini</h4>
                        <ul>
                            <li>Ajuda a ouvir e perceber as conversas</li>
                            <li>Tão pequeno como um botão</li>
                            <li>Fica escondido no ouvido</li>
                        </ul>
                    </div>
                </div>
            </footer>
        </main>
    </div>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/partials/_variables";
@import "~@/assets/scss/partials/_fonts";

header {
    @apply tw-bg-white;

    .tw-container {
        @apply tw-py-3;

        >img {
            @apply tw-pointer-events-none tw-mx-auto;
            width: 140px;
            height: 51.77px;
        }
    }
}

main {

    section {

        &.hero {
            background-color: $grey-light;
            //min-height: 100vh;

            .info-container {
                padding-top: 34px;

                @screen lg {
                    padding-top: 60px;
                }

                small {
                    @apply tw-block tw-py-1 tw-px-2 tw-uppercase tw-text-white tw-mx-auto tw-w-fit;
                    font-size: 17px;
                    border-radius: 7px;
                    background-color: $dark-grey;
                    line-height: 18px;

                    @screen lg {
                        font-size: 18px;
                    }
                }

                h1 {
                    @apply tw-text-center tw-font-bold tw-mt-1;
                    font-size: 28px;
                    color: $main_color;
                    line-height: 33px;

                    @screen lg {
                        font-size: 40px;
                        line-height: 47px;
                    }
                }
            }
        }
    }

    footer {
        @apply tw-relative tw-pt-4 tw-bg-no-repeat tw-bg-cover tw-pb-2;
        height: auto;
        background-color: $grey-light;
        background-position: center 22.5px;
        background-image: url('~@/assets/img/footer-bg-mobile.svg');

        @screen lg {
            @apply tw-pt-10 tw-bg-no-repeat tw-bg-cover tw-bg-center;
            background-image: url('~@/assets/img/footer-bg.svg');
            height: 280px;
        }

        .tw-container {
            @apply tw-z-10;

            @screen lg {
                max-width: 950px;
            }

            >div {
                z-index: 20 !important;

                >img {
                    margin-top: -40px;

                    @screen lg {
                        margin-top: -80px;
                        width: 545px;
                    }
                }

                &:last-of-type {
                    width: 330px;
                    @apply tw-mx-auto;

                    @screen lg {
                        @apply tw-w-auto tw-mx-0;
                    }

                    h4 {
                        @apply tw-font-bold tw-mb-1 tw-text-white tw-text-xl tw-mt-8;

                        @screen lg {
                            margin-top: 75px;
                            font-size: 22px;
                        }
                    }

                    ul {
    
                        li {
                            @apply tw-text-white tw-text-base tw-mb-2 tw-pl-3;
    
                            &::before {
                                @apply tw-relative;
                                top: 2.5px;
                                left: -12px;
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'%3E%3Cg id='Icon_ionic-ios-checkmark-circle-outline' data-name='Icon ionic-ios-checkmark-circle-outline' transform='translate(-3.375 -3.375)'%3E%3Cpath id='Path_5268' data-name='Path 5268' d='M19.188,12.995l-.719-.74a.155.155,0,0,0-.114-.049h0a.148.148,0,0,0-.114.049l-4.986,5.022L11.44,15.463a.158.158,0,0,0-.229,0l-.727.727a.163.163,0,0,0,0,.233l2.288,2.288a.724.724,0,0,0,.478.233.758.758,0,0,0,.474-.225h0l5.464-5.492A.175.175,0,0,0,19.188,12.995Z' transform='translate(-2.956 -3.699)' fill='%23fff'/%3E%3Cpath id='Path_5269' data-name='Path 5269' d='M11.875,4.519a7.353,7.353,0,1,1-5.2,2.154,7.307,7.307,0,0,1,5.2-2.154m0-1.144a8.5,8.5,0,1,0,8.5,8.5,8.5,8.5,0,0,0-8.5-8.5Z' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A");
                            }
    
                            @screen lg {
                                @apply tw-text-lg;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
